import React, { Component } from 'react'
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-confirm-alert/src/react-confirm-alert.css'
import axios from 'axios'
import { Accordion, AccordionItem, AccordionItemButton, AccordionItemHeading, AccordionItemPanel } from 'react-accessible-accordion';
import { Alert, Container, Row, Col, Button} from "shards-react";
import { Redirect } from 'react-router-dom'
import {PropTypes} from 'prop-types'
import {connect} from 'react-redux'

import PageTitle from "./../../components/common/PageTitle";
import auth from '../../components/common/Auth';
import history from '../../history';


const parentUrl = process.env.REACT_APP_RE_URL;


class Endpoint extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      loading: true,
      alertVisible: true,
      endpoints: [],
      apiActionErr: null,
      apiErr: null
    }
  }

  _getEndpoint() {
    var id = this.props.id;
    const token = auth.getAccessToken()
    const url = parentUrl + "/smre/1.0/uris/"+id;
    const self = this;

    axios.get(
      url,
      {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            "Authorization" : "Bearer "+token
        }
      }
    )
    .then(function (response) {

      self.setState({
        loading: false,
        endpoint: response.data.uris,
        actions: response.data.actions,
        apiActionErr: null,
        apiErr: null
      })
    }).catch(function (error) {

      self.setState({
        loading: false,
        apiErr: error.response ? (error.response.data.message ? error.response.data : error.response.data.error) : error
      })

    });

  }


  componentDidMount () {
    this._getEndpoint()
  }

  goBack = () => {
    history.goBack();
  }

  retry = () => {
    this.setState({
      alertVisible: true,
      apiErr: null,
      loading: true,
      endpoints: []
    }, () => this._getEndpoints())
  }

  dismiss = () => {
    this.setState({ alertVisible: false });
  }

  render () {
    const endpoint = this.state.endpoint
    const actions = this.state.actions

    // if(auth.isAuthenticated()){
        if (this.state.loading) {
          return (
            <div>
              <Container fluid>
                <br/>
                <div className="container center">
                    <h5><i className="fas fa-spinner fa-pulse"></i> {this.context.t('Loading...')}</h5>
                </div>
              </Container>
            </div>
          )
        }

        if (this.state.apiErr) {
          return (
            <div>
              <Container fluid className="px-0">
                <Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}: {this.state.apiErr.message} </Alert>
              </Container>
                <Container fluid className="main-content-container px-4 pb-4">
                  <div className="error">
                    <div className="error__content">
                      <h2>500</h2>
                      <h3>{this.context.t('Something went wrong!')}</h3>
                      <p>{this.context.t('There was a problem on our end. Please try again later.')}</p>
                      <Button onClick={this.retry} pill><i className="material-icons">refresh</i> {this.context.t('Reload')}</Button>
                    </div>
                  </div>
                </Container>
            </div>
          )
        }



        let error
        if (this.state.apiActionErr) {
          error =  <Container fluid className="px-0"><Alert dismissible={this.dismiss} open={this.state.alertVisible} className="red mb-0"><i className="material-icons">error</i> {this.context.t('There was a mistake')}:  {this.state.apiActionErr.message}</Alert></Container>
        }

        return (
          <div>

            {error}

            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <PageTitle title={endpoint.uri +"     ("+ endpoint.version+")"} subtitle={this.context.t('Endpoint')} className="text-sm-left mb-3" />
                    <Button size="sm" theme="white" className="mb-2" pill onClick={e => {this.goBack()}}>
                        <i className="material-icons mx-3" style={{ float: "right", cursor: "pointer", fontSize: "12px"}}>arrow_back</i>
                    </Button>
                </Row>

                <br/>
                <Row>
                  <Col lg="12">
                  <Accordion>
                        { actions && actions.length > 0 ? actions && actions.map(action => {
                              return (
                                <AccordionItem>
                                  <AccordionItemHeading>
                                      <AccordionItemButton>
                                          {action.rel}
                                      </AccordionItemButton>
                                  </AccordionItemHeading>
                                  <AccordionItemPanel>
                                      <p>
                                         {action.uri}
                                         <Button size="sm" theme="primary" className="mb-2" pill style={{float: "right"}}>
                                            TEST
                                         </Button>
                                      </p>
                                  </AccordionItemPanel>
                                </AccordionItem>
                              )
                            }) : <tr><td><div className="alert alert-info">No hay metodos cargados.</div></td></tr>
                        }
                    </Accordion>
                  </Col>
                </Row>
            </Container>
            <br/>
            <br/>
          </div>

        )
    // }else{
    //     return <Redirect to='/' />
    // }

  }
}

Endpoint.contextTypes = {
  t: PropTypes.func.isRequired
}

export default connect(state => ({
  lang: state.i18nState.lang
}))(Endpoint)
